document.addEventListener('DOMContentLoaded', function() {
  // Initialize Portfolio Gallery
  const portfolioGalleries = document.querySelectorAll('.portfolio-gallery');
  
  portfolioGalleries.forEach(gallery => {
    // Set CSS variables based on data attributes
    const columnsDesktop = gallery.getAttribute('data-columns-desktop') || '3';
    const columnsTablet = gallery.getAttribute('data-columns-tablet') || '2';
    const columnsMobile = gallery.getAttribute('data-columns-mobile') || '1';
    const imageSpacing = gallery.getAttribute('data-spacing') || '16';
    const aspectRatio = gallery.getAttribute('data-aspect-ratio') || 'square';
    
    gallery.style.setProperty('--columns-desktop', columnsDesktop);
    gallery.style.setProperty('--columns-tablet', columnsTablet);
    gallery.style.setProperty('--columns-mobile', columnsMobile);
    gallery.style.setProperty('--image-spacing', imageSpacing);
    
    // Set aspect ratio class
    gallery.setAttribute('data-aspect-ratio', aspectRatio);
    
    // Initialize filtering
    initializeFiltering(gallery);
    
    // Initialize lightbox
    if (gallery.querySelector('.portfolio-gallery__lightbox')) {
      initializeLightbox(gallery);
    }
    
    // Center images for better composition
    centerImagesInContainers(gallery);
  });
  
  // Center images in their containers for better composition
  function centerImagesInContainers(gallery) {
    const images = gallery.querySelectorAll('.portfolio-gallery__image');
    
    images.forEach(img => {
      img.onload = function() {
        const imgWidth = img.naturalWidth;
        const imgHeight = img.naturalHeight;
        
        // Determine if image is portrait or landscape
        if (imgWidth > imgHeight) {
          // Landscape image - center vertically
          img.style.objectPosition = 'center center';
        } else {
          // Portrait image - center horizontally
          img.style.objectPosition = 'center center';
        }
      };
      
      // If image is already loaded
      if (img.complete) {
        const imgWidth = img.naturalWidth;
        const imgHeight = img.naturalHeight;
        
        if (imgWidth > imgHeight) {
          img.style.objectPosition = 'center center';
        } else {
          img.style.objectPosition = 'center center';
        }
      }
    });
  }
  
  // Initialize filtering
  function initializeFiltering(gallery) {
    const filterButtons = gallery.querySelectorAll('.portfolio-gallery__filter-button');
    const items = gallery.querySelectorAll('.portfolio-gallery__item');
    
    if (filterButtons.length === 0) return;
    
    filterButtons.forEach(button => {
      button.addEventListener('click', function() {
        const filter = this.getAttribute('data-filter');
        
        // Update active button
        filterButtons.forEach(btn => btn.classList.remove('active'));
        this.classList.add('active');
        
        // Filter items
        items.forEach(item => {
          if (filter === 'all') {
            item.classList.remove('hidden');
          } else {
            if (item.classList.contains(`filter-${filter}`)) {
              item.classList.remove('hidden');
            } else {
              item.classList.add('hidden');
            }
          }
        });
      });
    });
  }
  
  // Initialize lightbox
  function initializeLightbox(gallery) {
    const lightbox = gallery.querySelector('.portfolio-gallery__lightbox');
    const lightboxImage = lightbox.querySelector('.portfolio-gallery__lightbox-image');
    const closeButton = lightbox.querySelector('.portfolio-gallery__lightbox-close');
    const prevButton = lightbox.querySelector('.portfolio-gallery__lightbox-prev');
    const nextButton = lightbox.querySelector('.portfolio-gallery__lightbox-next');
    const zoomButtons = gallery.querySelectorAll('.portfolio-gallery__zoom-button');
    const galleryImages = gallery.querySelectorAll('.portfolio-gallery__image');
    
    let currentIndex = 0;
    const images = Array.from(galleryImages).map(img => ({
      src: img.getAttribute('data-full-image') || img.src,
      alt: img.alt
    }));
    
    // Open lightbox when zoom button is clicked
    zoomButtons.forEach((button, index) => {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        openLightbox(index);
      });
    });
    
    // Open lightbox when image is clicked (if no zoom button)
    galleryImages.forEach((image, index) => {
      image.addEventListener('click', function(e) {
        // Only open lightbox if clicked directly on image (not on zoom button)
        if (e.target === this) {
          e.preventDefault();
          openLightbox(index);
        }
      });
    });
    
    // Close lightbox
    closeButton.addEventListener('click', closeLightbox);
    lightbox.addEventListener('click', function(e) {
      if (e.target === lightbox) {
        closeLightbox();
      }
    });
    
    // Navigate through images
    prevButton.addEventListener('click', showPrevImage);
    nextButton.addEventListener('click', showNextImage);
    
    // Keyboard navigation
    document.addEventListener('keydown', function(e) {
      if (!lightbox.classList.contains('active')) return;
      
      if (e.key === 'Escape') {
        closeLightbox();
      } else if (e.key === 'ArrowLeft') {
        showPrevImage();
      } else if (e.key === 'ArrowRight') {
        showNextImage();
      }
    });
    
    function openLightbox(index) {
      currentIndex = index;
      updateLightboxImage();
      lightbox.classList.add('active');
      document.body.style.overflow = 'hidden';
    }
    
    function closeLightbox() {
      lightbox.classList.remove('active');
      document.body.style.overflow = '';
    }
    
    function showPrevImage() {
      currentIndex = (currentIndex - 1 + images.length) % images.length;
      updateLightboxImage();
    }
    
    function showNextImage() {
      currentIndex = (currentIndex + 1) % images.length;
      updateLightboxImage();
    }
    
    function updateLightboxImage() {
      // Fade out current image
      lightboxImage.style.opacity = '0';
      
      // After fade out, update image and fade in
      setTimeout(() => {
        lightboxImage.src = images[currentIndex].src;
        lightboxImage.alt = images[currentIndex].alt;
        lightboxImage.style.opacity = '1';
      }, 300);
    }
  }
  
  // Handle window resize
  window.addEventListener('resize', function() {
    portfolioGalleries.forEach(gallery => {
      centerImagesInContainers(gallery);
    });
  });
});